import React from "react";
import { Link } from "react-router-dom";

export default function ArticleHero({ article }) {
  const sectionLabel = article.section === "lifestyle" ? "Fashion & Lifestyle" : "Blog & News";
  const sectionPath = article.section === "lifestyle" ? "/lifestyle" : "/blog";

  return (
    <header className="track-hero">
      <div className="container">
        <nav className="track-breadcrumb">
          <Link to={sectionPath}>{sectionLabel}</Link>
          <span>/</span>
          <span className="current">{article.tag}</span>
        </nav>

        <div className="text-center mb-4">
          <span className="track-genre-badge-static">{article.tag}</span>
          <h1 className="article-title">{article.title}</h1>
          <div className="article-byline">
            <img src={article.authorAvatar} alt={article.author} />
            <span>By {article.author}</span>
            <span className="dot">&middot;</span>
            <span>{article.date}</span>
            <span className="dot">&middot;</span>
            <span>{article.readTime}</span>
          </div>
        </div>

        <div className="article-hero-image">
          <img src={article.heroImage} alt={article.title} />
        </div>
      </div>
    </header>
  );
}
